"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../../baseSchema");
const baseClickSchema_1 = require("../../baseSchema/baseClickSchema");
class ClickDismissMigrationNewClub extends baseClickSchema_1.BaseClickSchema {
    constructor({ componentName, productId }) {
        super({ componentName });
        this.action = baseSchema_1.ActionsName.CLICK_MIGRATION_MODAL_CLOSE;
        this.productId = productId;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            productId: this.productId,
            action: this.action
        };
    }
}
exports.default = ClickDismissMigrationNewClub;
